export enum QueryKeyEnum {
  ATTEMPT = 'ATTEMPT',
  ATTEMPT_DETAILS = 'ATTEMPT_DETAILS',
  ATTEMPT_TIMELINE = 'ATTEMPT_TIMELINE',
  BULK_PREVIEW = 'BULK_PREVIEW',
  CURRENT_USER = 'CURRENT_USER',
  EXAM = 'EXAM',
  FOCUS_QUESTION_IDS = 'FOCUS_QUESTION_IDS',
  JAIN_INTEGRATION = 'JAIN_INTEGRATION',
  LIST_ATTEMPTS = 'LIST_ATTEMPTS',
  LIST_CATEGORIES = 'LIST_CATEGORIES',
  LIST_POSITIONS = 'LIST_POSITIONS',
  LIST_PROCEDURE_NAMES = 'LIST_PROCEDURE_NAMES',
  LIST_QUESTIONS = 'LIST_QUESTIONS',
  LIST_SURVEY_RESPONSES = 'LIST_SURVEY_RESPONSES',
  LIST_SURVEYS = 'LIST_SURVEYS',
  LIST_TAGS = 'LIST_TAGS',
  LIST_TESTS = 'LIST_TESTS',
  MEDIA_INTEGRATION = 'MEDIA_INTEGRATION',
  PING = 'PING',
  QUESTION_DETAIL = 'QUESTION_DETAIL',
  QUESTION_HISTORY = 'QUESTION_HISTORY',
  QUESTION_IMPACT = 'QUESTION_IMPACT',
  QUESTION_STATISTICS = 'QUESTION_STATISTICS',
  QUESTION_VERSION = 'QUESTION_VERSION',
  SURVEY_DETAIL = 'SURVEY_DETAIL',
  SURVEY_HISTORY = 'SURVEY_HISTORY',
  SURVEY_PREVIEW = 'SURVEY_PREVIEW',
  SURVEY_RESPONSE = 'SURVEY_RESPONSE',
  SURVEY_RESPONSE_DETAILS = 'SURVEY_RESPONSE_DETAILS',
  TEST_DETAIL = 'TEST_DETAIL',
  TEST_HISTORY = 'TEST_HISTORY',
  TEST_PERSON = 'TEST_PERSON',
  TEST_POOL_PREVIEW = 'TEST_POOL_PREVIEW',
  TEST_SAMPLE = 'TEST_SAMPLE',
}
